import { UntypedFormControl } from '@angular/forms';

export interface ValidationResult {
  [key: string]: boolean;
}

export class EnrollmentValidator {
  static check(control: UntypedFormControl): ValidationResult | null {
    if (control.value && typeof control.value != 'undefined') {
      const test = /^[alAL][0-9]{8}$/.test(control.value);
      // console.log('Num, Upp, Low, Length', hasNumber, hasUpper, hasLower, hasMinLength);
      const valid = test;
      if (!valid) {
        // return what´s not valid
        return { check: true };
      }
      return null;
    }
    return null;
  }
}
